import type { TranslateAbleText } from '@pct-ng/i18n';
import { type TableColumnConfig } from '@pct-ng/feature-table-material';

export function createSimpleColumn<T>(
  id: string,
  field: keyof T,
  label: TranslateAbleText,
  sortable = false,
): TableColumnConfig<T> {
  return {
    id,
    field,
    label,
    sortable,
  };
}
